import { observable, action, flow, computed } from 'mobx';
import { rstr2b64 } from 'utils/md5';
import Util from 'utils';
import Config from 'config/Config';
import { Toast } from 'antd-mobile';
import Stores from 'config/Stores';
import Serv from './StudioMsgServ';

class StudioMsgMod {
  // 密码、重复密码
  @observable password = '';

  @observable passwordAgain = '';

  // 办公电话
  @observable officePhone = '';

  // 手机号码
  @observable phone = '';

  // 收货地址
  @observable address = [];

  // 详细地址
  @observable detailAddress = '';

  // 身份证正反面
  @observable imgList = ['', ''];

  // 手机号码
  @observable isAgree = false;

  // 是否弹出身份证示例
  @observable showExample = false;

  // 区域编码
  @observable areaCode = Stores.AppMod.isInternationalized ? 1 : 86;

  pageState = {};

  /**
   * 修改参数逻辑
   */
  @action
  changeState(key, value) {
    this[key] = value;
  }

  /**
   * 清空数据
   */
  @action
  clearData() {
    this.password = '';
    this.passwordAgain = '';
    this.officePhone = '';
    this.phone = '';
    this.address = [];
    this.detailAddress = '';
    this.imgList = ['', ''];
    this.isAgree = false;
  }

  /**
   * 提交工作室信息
   */
  submitStudioMsg = flow(function* () {
    try {
      const applyStoreMsg = Util.getLocalCache(Config.localStorageKeys.member_applyStoreMsg) || {};
      // 如果店铺信息还未填写，或者填写店铺信息时是否处于登录状态与当前是否处于登录状态不一致，则跳回重新填写店铺信息
      if (!applyStoreMsg.registerCardReqDto) {
        Toast.info('您还未提交店铺信息，请前往填写', 1, () => {
          window.app.router.goBack();
        });
        return;
      }
      if (!/^[0-9]*$/.test(this.officePhone.replace(/(\s|-)/g, ''))) {
        Toast.info('办公电话输入有误，请重新输入~');
        return;
      }
      if (!Util.checkInput(this.phone.replace(/\s/g, ''), 'mobile')) {
        Toast.info('手机号码输入有误，请重新输入~');
        return;
      }
      if (this.password.length < 8) {
        Toast.info('密码长度不能少于8位', 1);
        return;
      }
      if (!Util.checkInput(this.password, 'password')) {
        Toast.info('密码必须8~16位包含大小写字母、数字和特殊字符', 2);
        return;
      }
      if (this.password !== this.passwordAgain) {
        Toast.info('两次输入的密码不匹配', 1);
        return;
      }
      // if (this.detailAddress.length < 7) {
      //   Toast.info('详细地址长度不得小于7位', 1);
      //   return;
      // }
      const list = ['province', 'city', 'county', 'street', 'community'];
      const addressObj = {};
      this.address.forEach((e, i) => {
        addressObj[`${list[i]}Name`] = e.label;
        addressObj[`${list[i]}Code`] = e.value;
      });
      // 补充未选到的级别字段为空字符串（选了"暂不选择"时数组会截断）
      for (let i = this.address.length; i < list.length; i++) {
        addressObj[`${list[i]}Name`] = '';
        addressObj[`${list[i]}Code`] = '';
      }
      addressObj.areaCode = addressObj.countyCode;
      addressObj.areaName = addressObj.countyName;
      let params = {
        registerType: applyStoreMsg.registerType,
        registerCardReqDto: {
          ...applyStoreMsg.registerCardReqDto,
          identityCardImg: this.imgList
        },
        shopContactInfoDto: {
          storePassword: rstr2b64(this.password),
          cellphone: this.phone.replace(/\s/g, ''),
          cellphoneAreaCode: this.areaCode,
          officePhone: null,
          deliveryAddress: {
            ...this.pageState,
            // 街道赋值一个空值 解决后台回显的时候 数据为null问题
            streetName: '',
            streetCode: '',
            ...addressObj,
            // provinceCode: this.address[0].value,
            // provinceName: this.address[0].label,
            // cityCode: this.address[1].value,
            // cityName: this.address[1].label,
            // countyCode: this.address[2].value,
            // countyName: this.address[2].label,
            // areaCode: this.address[2].value,
            // areaName: this.address[2].label,
            detailAddress: this.detailAddress,
            address: this.detailAddress,
            deliveryName: applyStoreMsg.registerCardReqDto.realName,
            deliveryMobile: this.phone.replace(/\s/g, '')
          }
        }
      };
      if (this.officePhone) {
        params.shopContactInfoDto.officePhone = this.officePhone.replace(/(\s|-)/g, '');
      }
      yield Serv.submitStudioMsg(params);
      Util.setLocalCache(Config.localStorageKeys.member_applyStoreMsg, params);
      window.app.routerGoTo({
        pathname: '/register/storeGiftbag',
        clear: true,
        state: this.pageState.storeTypeId
          ? {
              storeTypeId: this.pageState.storeTypeId
            }
          : {}
      });
    } catch (error) {}
  });

  /**
   * 获取工作室类型详情
   */
  getStoreTypeInfoById = flow(function* (storeTypeId) {
    try {
      const { resultCode, data } = yield Serv.getStoreTypeInfoById(storeTypeId);
      if (resultCode + '' === '0') {
        return data || {};
      }
    } catch (error) {
      console.log(error, 'getStoreTypeInfoById--error');
    }
  });

  /**
   * 按钮是否不可点击
   */
  @computed
  get disabled() {
    return !(
      `${this.password}` &&
      `${this.passwordAgain}` &&
      // `${this.officePhone}` &&
      `${this.phone}` &&
      this.address[0] &&
      this.detailAddress &&
      this.imgList[0] &&
      this.imgList[1]
    );
  }
}
const studioMsgMod = new StudioMsgMod();
export default studioMsgMod;



// WEBPACK FOOTER //
// ./src/pages/Register/StudioMsg/StudioMsgMod.js